Controller.$inject = [];

function Controller() {

}

export function HuiProgressBar() {
    return {
        restrict: 'E',
        replace: true,
        scope: true,
        bindToController: {
            progress: '@',
            color: '@'
        },
        controller: Controller,
        controllerAs: '$huiCtrl',
        transclude: true,
        template: ($element, $attrs) => {
            return `
                <div class="hui-progress-bar" 
                     ng-class="['hui-' + ($huiCtrl.color || 'accent')]" 
                     ng-style="{ width: $huiCtrl.progress + '%' }"></div>
            `;
        }
    }
}